import { DateFormatter } from '@repo/toolkit/date'

import { BillingTypeEnum } from '../../types/enums/cse/billing-type.enum'
import { EnrollmentAccountingFilters } from '../../types/models/enrollment/enrollment-accounting-filters'

export const transformEnrollmentAccountingFiltersToUrl = (
  filters?: EnrollmentAccountingFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countryCodes && filters.countryCodes.length)
    searchParams.append('country_codes', filters.countryCodes.join(','))

  if (filters.confirmedAt) searchParams.append('confirmed_at', filters.confirmedAt)

  if (filters.fullyPaid !== undefined) searchParams.append('fully_paid', String(filters.fullyPaid))

  if (filters.cseBillingTypes?.length)
    searchParams.append('cse_billing_types', filters.cseBillingTypes.join(','))

  if (filters.cseId !== undefined) searchParams.append('cse_id', String(filters.cseId))

  return searchParams.toString()
}

export const transformUrlToEnrollmentAccountingFilters = (
  searchParams: URLSearchParams
): EnrollmentAccountingFilters => {
  const filters: EnrollmentAccountingFilters = {}

  const countryCodes = searchParams.get('country_codes')
  if (countryCodes && countryCodes.length) filters.countryCodes = countryCodes.split(',')

  const confirmedAt = DateFormatter.checkDateFormat(searchParams.get('confirmed_at'))
  if (confirmedAt) filters.confirmedAt = confirmedAt
  const fullyPaid = searchParams.get('fully_paid')
  if (fullyPaid !== null) filters.fullyPaid = fullyPaid === 'true'

  const cseBillingTypes = searchParams.get('cse_billing_types')
  if (cseBillingTypes?.length)
    filters.cseBillingTypes = cseBillingTypes.split(',') as BillingTypeEnum[]

  const cseId = searchParams.get('cse_id')
  if (cseId !== null) filters.cseId = parseInt(cseId, 10)

  return filters
}
